import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Grid,
  Typography,
  useTheme,
  MenuItem,
  Select,
} from "@mui/material";
import ImageSlideshow from "../../components/ImageSlideShow";
import { ZoomInRounded } from "@mui/icons-material";
import TransitionsModal from "../../components/modal/modal";
import ImageSlider from "../../components/ImageSlider";
import ContentLayout from "../../components/ContentLayout";
import NeuroCampImg from "../../static_data/event_image/curricular/2024_25/31stAugustNeuroCamp.json";
import BloodStemImg from "../../static_data/event_image/curricular/2024_25/30st_August_Blood_Stem.json";
import WorldOrganDonationDayImg from "../../static_data/event_image/curricular/2024_25/13August_World_Organ_Donation_Day.json";
import AugustBreastfeedingawarenessPHCImg from "../../static_data/event_image/curricular/2024_25/7August_Breastfeeding_awareness_PHC.json";
import ExtemporeCompetitionImg from "../../static_data/event_image/curricular/2024_25/9_03_2024_EXTEMPORE_COMPETITION.json";
import JohnDereMarathonImg from "../../static_data/event_image/curricular/2024_25/11_02_2025_THE_JOHN_DERE_MARATHON.json";
import WorldDisabilityDayImg from "../../static_data/event_image/curricular/2024_25/12_03_2024_WORLD_DISABILITY_DAY_2024.json";
import SeniorFitnessTestImg from "../../static_data/event_image/curricular/2024_25/12_03_2024_Senior_Fitness_test_assessment_in_geriatrics.json";
import SynopsisWritingWorkshopImg from "../../static_data/event_image/curricular/2024_25/11_03_2024_SYNOPSIS_WRITING_WORKSHOP.json";
import PhysiotherapyCampImg from "../../static_data/event_image/curricular/2024_25/30_06_2024_PHYSIOTHERAPY_CAMP_IN_SAKAL.json";
import WorldYogaDayImg from "../../static_data/event_image/curricular/2024_25/21_06_2024_WORLD_YOGA_DAY.json";
import FreeHealthCheckUpCampImg from "../../static_data/event_image/curricular/2024_25/20_06_2024_FREE_HEALTH_CHECK_UP_CAMP_AT_POLICE_SOCIETY_1.json";
import WorldNatureConservationDayImg from "../../static_data/event_image/curricular/2024_25/27_07_2024_WORLD_NATURE_CONSERVATION_DAY.json";
import CareerCounsellingSeminarImg from "../../static_data/event_image/curricular/2024_25/24_08_2024_CAREER_COUNSELLING_SEMINAR.json";
import RecruitmentDriveImg from "../../static_data/event_image/curricular/2024_25/10_08_2024_RECRUITMENT_DRIVE.json";
import RallyImg from "../../static_data/event_image/curricular/2024_25/sep/2ND_SEPT_RALLY.json";
import IndustrialVisitImg from "../../static_data/event_image/curricular/2024_25/sep/3_sept_INDUSTRIAL_VISIT.json";
import CampImg from "../../static_data/event_image/curricular/2024_25/sep/4_SEPT_CAMP.json";
import BhauRangariFreeCampImg from "../../static_data/event_image/curricular/2024_25/sep/13_sept_bhau_rangari_free_camp.json";
import CMEImg from "../../static_data/event_image/curricular/2024_25/sep/20_sept_CME.json";
import WorldHeartDayBLSImg from "../../static_data/event_image/curricular/2024_25/sep/23_sept_world_heart_day_BLS.json";
import POSHTrainingActivityImg from "../../static_data/event_image/curricular/2024_25/nov/29TH_NOVEMBER_2024_POSH_TRAINING_ACTIVITY.json";
import WorldCOPDDayImg from "../../static_data/event_image/curricular/2024_25/nov/22ND_NOVEMBER_2024_WORLD_COPD_DAY.json";
import CareerCounsellingSeminarDecImg from "../../static_data/event_image/curricular/2024_25/dec/9TH_DECEMBER_2024_CAREER_COUNSELLING_SEMINAR.json";
import PhysiotherapyCampDecImg from "../../static_data/event_image/curricular/2024_25/dec/20TH_DECEMBER_2024_PHYSIOTHERAPY_CAMP.json";
import DagdusethMandirPhysiotherapyCampImg from "../../static_data/event_image/curricular/2024_25/dec/20_12_2025_DAGDUSETH_MANDIR_PHYSIOTHERAPY_CAMP.json";
import NeuroCampFebImg from "../../static_data/event_image/curricular/2024_25/feb/05_02_2025_NEURO_CAMP.json";
import DisasterManagementSeminarImg from "../../static_data/event_image/curricular/2024_25/jan/03_01_2024_DISASTER_MANAGEMENT_SEMINAR.json";
import IntroductionToOrthosisAndProsthesisImg from "../../static_data/event_image/curricular/2024_25/jan/10_01_2024_INTRODUCTION_TO_ORTHOSIS_AND_PROSTHESIS.json";
import FreeHealthCampImg from "../../static_data/event_image/curricular/2024_25/jan/12_01_2025_free_health_camp_organized_by_Maharashtra_Navnirman_Sena.json";
import ElectrotherapyActivityImg from "../../static_data/event_image/curricular/2024_25/jan/17_01_2025_ELECTROTHERAPY_ACTIVITY.json";
import GuestLectureOnHumanMeasurementTechnologyImg from "../../static_data/event_image/curricular/2024_25/jan/17_01_2025_GUEST_LECTURE_ON_HUMAN_MEASUREMENT_TECHNOLOGY.json";
import MSKCampImg from "../../static_data/event_image/curricular/2024_25/jan/28_01_2024_MSK_CAMP_IN MODERN_SCHOOL.json";
import EmpoweringParentsImg from "../../static_data/event_image/curricular/2024_25/jan/29_01_2025_Empowering_Parents_Regarding_Role_of_Physiotherapy_in_rehabilitation_of_special_children.json";
import RtoSportsEventsImg from "../../static_data/event_image/curricular/2024_25/jan/30_01_2025_january_30th_to_February_1st_RTO_SPORTS_EVENTS.json";

import CouncilElection2025 from "../../static_data/event_image/curricular/2024_25/march/CouncilElection.json";
import Camp2025 from "../../static_data/event_image/curricular/2024_25/march/Camp.json";
import Synopsis from "../../static_data/event_image/curricular/2024_25/march/synopsis.json";
// import TOTCompetency from "../../static_data/event_image/curricular/2024_25/TOT_Competency_Based_Syllabus_Workshop.json";
import CampAtMath from "../../static_data/event_image/curricular/2024_25/Camp_at_Shri_Sadguru_Shankar_Maharaj_Math.json";
import HealthCamp from "../../static_data/event_image/curricular/2024_25/Health_camp_with_Dagduseth_halwai_trust.json";
import DownsDay from "../../static_data/event_image/curricular/2024_25/Down_Syndrome_Day_Celebration.json";
import TapingManagement from "../../static_data/event_image/curricular/2024_25/Taping_and_Its_management_in_sports_injuries_2025.json";
import parkinsonDay from "../../static_data/event_image/curricular/2024_25/world_parkinson_day.json";
import autismDay from "../../static_data/event_image/curricular/2024_25/world_autism_day.json";

//2025-26
import PoliceQuatersCamp from "../../static_data/event_image/curricular/2025_26/jun/Camp_at_Police_Quaters_Shivajinagar.json";
import YogaDay2025 from "../../static_data/event_image/curricular/2025_26/jun/World_Yoga_Day2025.json";
import iastm25 from "../../static_data/event_image/curricular/2025_26/AUG/iastm.json";
import SpinalCordInjuryAwarenessDay2025 from "../../static_data/event_image/curricular/2025_26/SEP/SpinalCordInjuryAwarenessDay.json";
import SloganWritingCompetition from "../../static_data/event_image/curricular/2025_26/SEP/SloganWritingCompetition.json";
import BharatHealthCapital from "../../static_data/event_image/curricular/2025_26/SEP/BharatHealthCapital.json";
import PersonalityDevelopmentSession from "../../static_data/event_image/curricular/2025_26/SEP/PersonalityDevelopmentSession.json";
import Financial_Awareness_Session from "../../static_data/event_image/curricular/2025_26/SEP/Financial_Awareness_Session.json";
import BOLLY_HOP from "../../static_data/event_image/curricular/2025_26/SEP/BOLLY_HOP.json";
import MotionSickness from "../../static_data/event_image/curricular/2025_26/SEP/MotionSickness.json";
import Advanced_First_Aid from "../../static_data/event_image/curricular/2025_26/SEP/Advanced_First_Aid.json";
import CPR_AED_Training from "../../static_data/event_image/curricular/2025_26/SEP/CPR_AED_Training.json";
import physicalActivity from "../../static_data/event_image/curricular/2025_26/FEB/PhysicalActivityScreening.json";
import FreePhysiotherapy from "../../static_data/event_image/curricular/2025_26/FEB/FreePhysiotherapyAssessment.json";
import CME_Exercise from "../../static_data/event_image/curricular/2025_26/April_May/CMEAerobicExercises.json";
import SpinalManipulation from "../../static_data/event_image/curricular/2025_26/April_May/SpinalManipulation.json";
import WorldAnkylosingSpondylitis from "../../static_data/event_image/curricular/2025_26/April_May/WorldAnkylosingSpondylitis.json";

// 2026_27
import KINESWHISPER from "../../static_data/event_image/curricular/2026_27/aug/KINESWHISPER.json";
import FINANCIALWELLBEING from "../../static_data/event_image/curricular/2026_27/aug/FINANCIALWELLBEING.json";
import WorldSpinalCordInjuryDay from "../../static_data/event_image/curricular/2026_27/sep/WorldSpinalCordInjuryDay.json";
import WorldHeartDay from "../../static_data/event_image/curricular/2026_27/oct/WorldHeartDay.json";

type Years = Array<{
  year: string;
  data: Array<CurricularEventObject>;
}>;

type EventsProps = {
  data: Array<CurricularEventObject>;
};

type ImageType = {
  src: string;
  alt: string;
};

type CurricularEventObject = {
  title: string;
  description?: string;
  img?: Array<ImageType>;
  date?: Date | String;
};

const curricularEventsData_2026_27: Array<CurricularEventObject> = [
  {
    title: "World heart day 26-CME on Heart Transplantation & Rehabilitation",
    img: WorldHeartDay.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2026_27/Worldheartday/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "06/10/2026",
  },
  {
    title: "World Spinal Cord Injury Day 2026",
    img: WorldSpinalCordInjuryDay.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2026_27/WorldSpinalCordInjuryDay/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "03/09/2026",
  },
  {
    title: "KINES WHISPER",
    img: KINESWHISPER.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2026_27/KINESWHISPER/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "06/08/2026",
  },
  {
    title: "FINANCIAL WELLBEING",
    img: FINANCIALWELLBEING.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2026_27/FINANCIALWELLBEING/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "04/08/2026",
  }
];

const curricularEventsData_2025_26: Array<CurricularEventObject> = [
  {
    title: "Awareness Program on World Ankylosing Spondylitis Day",
    img: WorldAnkylosingSpondylitis.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/WorldAnkylosingSpondylitis/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "07/05/2026",
  },
  {
    title: "Spinal Manipulation Workshop",
    img: SpinalManipulation.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/SpinalManipulation/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "27/03/2026",
  },
  {
    title: "CME on Aerobic Exercises & Testing",
    img: CME_Exercise.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/CME_Aerobic_Exercises_Testing/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "16/04/2026",
  },
  {
    title: "Free Physiotherapy Assessment & Treatment camp at Gaothan ganesh utsav trust Rokdoba mandir, Shivaji nagar",
    img: FreePhysiotherapy.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/FreePhysiotherapyAssessmentandTreatmentcampatGaothanganeshutsavtrustRokdobamandir/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "21/02/2026",
  },
  {
    title: "Physical Activity Screening and Awareness Camp",
    img: physicalActivity.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/PhysicalActivityScreeningandAwarenessCamp/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "03/02/2026",
  },
  {
    title: "Hand’ s On Training on “CPR & AED Training”",
    img: CPR_AED_Training.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/CPR_AED_Training/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "29/09/2025",
  },
  {
    title: "Advanced First Aid",
    img: Advanced_First_Aid.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/Advanced_First_Aid/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "25/09/2025",
  },
  {
    title: "World Physiotherapy week- Role of Physiotherapy in Motion Sickness",
    img: MotionSickness.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/MotionSickness/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "12/09/2025",
  },
  {
    title: "World Physiotherapy week- BOLLY-HOP- Therapeutic Beats, Dance as Exercise",
    img: BOLLY_HOP.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/BOLLY-HOP/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "11/09/2025",
  },
  {
    title: "World Physiotherapy week- Financial Awareness Session",
    img: Financial_Awareness_Session.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/Financial_Awareness_Session/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "11/09/2025",
  },
  {
    title: "World Physiotherapy week- Personality Development Session",
    img: PersonalityDevelopmentSession.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/PersonalityDevelopmentSession/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "10/09/2025",
  },
  {
    title: " World Physiotherapy week- Let's make Bharat a Health Capital of the World",
    img: BharatHealthCapital.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/BharatHealthCapital/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "09/09/2025",
  },
  {
    title: "World Physiotherapy week- Slogan Writing Competition",
    img: SloganWritingCompetition.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/SloganWritingCompetition/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "08/09/2025",
  },
  {
    title: "Spinal Cord Injury Awareness Day",
    img: SpinalCordInjuryAwarenessDay2025.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/SpinalCordInjuryAwarenessDay2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "03/09/2025",
  },
  {
    title: "IASTM Workshop",
    img: iastm25.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/IASTM/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "20/08/2025",
  },
  {
    title: "Physiotherapy camp at Police Quarters, Shivajinagar",
    img: PoliceQuatersCamp.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/Camp_at_Police_Quaters_Shivajinagar/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "29/07/2025",
  },
  {
    title: "World Yoga Day 2025 ",
    img: YogaDay2025.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2025_26/World_Yoga_Day2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "21/06/2025",
  },
];

const curricularEventsData_2024_25: Array<CurricularEventObject> = [
  {
    title: "World Autism Day ",
    img: autismDay.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/World_Autism_Day/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  {
    title: "World Parkinson's Day ",
    img: parkinsonDay.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/World_Parkinson_Day_Poster_making_competition/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  {
    title: "Taping & it's management in sports",
    img: TapingManagement.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/Taping_and_Its_management_in_sports_injuries_2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  {
    title: "Down Syndrome Day Celebration",
    img: DownsDay.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/Down_Syndrome_Day_Celebration/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  {
    title: "Health Camp at Dagduseth Halwai Trust",
    img: HealthCamp.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/Health_camp_with_Dagduseth_halwai_trust/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  {
    title: "Camp at Shri Sadguru Shankar Maharaj Math",
    img: CampAtMath.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/Camp_at_Shri_Sadguru_Shankar_Maharaj_Math/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "",
  },
  // {
  //   title: "TOT Competency Based Syllabus Workshop",
  //   img: TOTCompetency.images.map((image) => ({
  //     src: require(`../../assets/images/events/Curricular/2024_25/TOT_Competency_Based_Syllabus_Workshop/${image.src.split('/').pop()}`),
  //     alt: image.title,
  //   })),
  //   date: "",
  // },
  //  {
  //   title: "Downs Syndrome Day Celebration",
  //   img: Syndrom.images.map((image) => ({
  //     src: require(`../../assets/images/events/Curricular/2024_25/Downs_Syndrome_Day_Celebration/${image.src.split('/').pop()}`),
  //     alt: image.title,
  //   })),
  //   date: "",
  // },
  {
    title: "Synopsis Writing Seminar",
    img: Synopsis.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/march/SYNOPSIS_WRITING_SEMINAR_2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "21/03/2025",
  },
  {
    title: "Cardiopulmonary Screening Camp",
    img: Camp2025.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/march/CARDIOPULMONARY_SCREENING_CAMP_2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "19/03/2025",
  },
  {
    title: "Student Council Elections",
    img: CouncilElection2025.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/march/council_election_2025/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "13/03/2025",
  },
  {
    title: "Neuro Camp",
    img: NeuroCampFebImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/feb/05_02_2025_NEURO_CAMP/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "05/02/2025",
  },
  {
    title: "30th January to 1st February RTO SPORTS EVENTS",
    img: RtoSportsEventsImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/jan/30_01_2025_january_30th_to_February_1st_RTO_SPORTS_EVENTS/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "30/01/2025",
  },

  {
    title: "Empowering Parents Regarding Role of Physiotherapy in Rehabilitation of Special Children",
    img: EmpoweringParentsImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/jan/29_01_2025_Empowering_Parents_Regarding_Role_of_Physiotherapy_in_rehabilitation_of_special_children/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "29/01/2025",
  },

  {
    title: "Electrotherapy Activity",
    img: ElectrotherapyActivityImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/jan/17_01_2025_ELECTROTHERAPY_ACTIVITY/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "17/01/2025",
  },
  {
    title: "Guest Lecture on Human Measurement Technology",
    img: GuestLectureOnHumanMeasurementTechnologyImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/jan/17_01_2025_GUEST_LECTURE_ON_HUMAN_MEASUREMENT_TECHNOLOGY/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "17/01/2025",
  },
  {
    title: "Free Health Camp Organized by Maharashtra Navnirman Sena",
    img: FreeHealthCampImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/jan/12_01_2025_free_health_camp_organized_by_Maharashtra_Navnirman_Sena/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "12/01/2025",
  },

  {
    title: "Physiotherapy Camp (December)",
    img: PhysiotherapyCampDecImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/dec/20TH_DECEMBER_2024_PHYSIOTHERAPY_CAMP/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "20/12/2024",
  },
  {
    title: "Dagduseth Mandir Physiotherapy Camp",
    img: DagdusethMandirPhysiotherapyCampImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/dec/20_12_2025_DAGDUSETH_MANDIR_PHYSIOTHERAPY_CAMP/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "20/12/2025",
  },
  {
    title: "Career Counselling Seminar (December)",
    img: CareerCounsellingSeminarDecImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/dec/9TH_DECEMBER_2024_CAREER_COUNSELLING_SEMINAR/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "09/12/2024",
  },

  {
    title: "POSH Training Activity",
    img: POSHTrainingActivityImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/nov/29TH_NOVEMBER_2024_POSH_TRAINING_ACTIVITY/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "29/11/2024",
  },
  {
    title: "World COPD Day",
    img: WorldCOPDDayImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/nov/22ND_NOVEMBER_2024_WORLD_COPD_DAY/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "22/11/2024",
  },
  {
    title: "2ND SEPT RALLY",
    img: RallyImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/sep/2ND_SEPT_RALLY/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "02/09/2024",
  },
  {
    title: "3RD SEPT INDUSTRIAL VISIT",
    img: IndustrialVisitImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/sep/3_sept_INDUSTRIAL_VISIT/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "03/09/2024",
  },
  {
    title: "4TH SEPT CAMP",
    img: CampImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/sep/4_SEPT_CAMP/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "04/09/2024",
  },
  {
    title: "13TH SEPT BHAU RANGARI FREE CAMP",
    img: BhauRangariFreeCampImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/sep/13_sept_bhau_rangari_free_camp/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "13/09/2024",
  },
  {
    title: "20TH SEPT CME",
    img: CMEImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/sep/20_sept_CME/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "20/09/2024",
  },
  {
    title: "23RD SEPT WORLD HEART DAY BLS",
    img: WorldHeartDayBLSImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/sep/23_sept_world_heart_day_BLS/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "23/09/2024",
  },


  {
    title: "Neuro Physiotherapy Department with AVANI Foundation",
    img: NeuroCampImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/31st_august_neuro_camp/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "31/08/2024",
  },
  {
    title: "Blood Stem Cell Donation Awareness seminar",
    img: BloodStemImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/30st_August_Blood_Stem/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "30/08/2024",
  },
  // {
  //   title: "26th AUGUST 2024 : Gender Equity Day seminar",
  //   img: [],
  //   date: "26/08/2024",
  // },
  // {
  //   title: "24TH AUGUST 2024: Study Abroad with Travelogue",
  //   img: [],
  //   date: "24/08/2024",
  // },
  {
    title: "Career Counselling Seminar",
    img: CareerCounsellingSeminarImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/24_08_2024_CAREER_COUNSELLING_SEMINAR/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "24/08/2024",
  },

  {
    title: "World Organ Donation Day",
    img: WorldOrganDonationDayImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/13August_World_Organ_Donation_Day/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "13/08/2024",
  },
  // {
  //   title: "10th AUGUST 2024: Recruitment drive",
  //   img: [],
  //   date: "10/08/2024",
  // },
  {
    title: "Recruitment Drive",
    img: RecruitmentDriveImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/10_08_2024_RECRUITMENT_DRIVE/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "10/08/2024",
  },

  {
    title: "Breastfeeding awareness program at PHC",
    img: AugustBreastfeedingawarenessPHCImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/7August_Breastfeeding_awareness_PHC/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "07/08/2024",
  },
  // {
  //   title: "4th AUGUST 2024: Karyasamrat Free Mega Health Camp",
  //   img: [],
  //   date: "04/08/2024",
  // },
  {
    title: "World Nature Conservation Day",
    img: WorldNatureConservationDayImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/27_07_2024_WORLD_NATURE_CONSERVATION_DAY/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "27/07/2024",
  },

  {
    title: "Physiotherapy Camp in Sakal",
    img: PhysiotherapyCampImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/30_06_2024_PHYSIOTHERAPY_CAMP_IN_SAKAL/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "30/06/2024",
  },
  {
    title: "World Yoga Day",
    img: WorldYogaDayImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/21_06_2024_WORLD_YOGA_DAY/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "21/06/2024",
  },
  {
    title: "Free Health Check-Up Camp at Police Society",
    img: FreeHealthCheckUpCampImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/20_06_2024_FREE_HEALTH_CHECK_UP_CAMP_AT_POLICE_SOCIETY_1/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "20/06/2024",
  },


  {
    title: "World Disability Day 2024",
    img: WorldDisabilityDayImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/12_03_2024_WORLD_DISABILITY_DAY_2024/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "12/03/2024",
  },
  {
    title: "Senior Fitness Test Assessment in Geriatrics",
    img: SeniorFitnessTestImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/12_03_2024_Senior_Fitness_test_assessment_in_geriatrics/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "12/03/2024",
  },
  {
    title: "Synopsis Writing Workshop",
    img: SynopsisWritingWorkshopImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/11_03_2024_SYNOPSIS_WRITING_WORKSHOP/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "11/03/2024",
  },
  {
    title: "Extempore Competition 2024",
    img: ExtemporeCompetitionImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/9_03_2024_EXTEMPORE_COMPETITION/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "09/03/2024",
  },
  {
    title: "The John Dere Marathon",
    img: JohnDereMarathonImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/11_02_2025_THE_JOHN_DERE_MARATHON/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "11/02/2024",
  },
  {
    title: "MSK Camp in Modern School",
    img: MSKCampImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/jan/28_01_2024_MSK_CAMP_IN MODERN_SCHOOL/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "28/01/2024",
  },

  {
    title: "Introduction to Orthosis and Prosthesis",
    img: IntroductionToOrthosisAndProsthesisImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/jan/10_01_2024_INTRODUCTION_TO_ORTHOSIS_AND_PROSTHESIS/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "10/01/2024",
  },


  {
    title: "Disaster Management Seminar",
    img: DisasterManagementSeminarImg.images.map((image) => ({
      src: require(`../../assets/images/events/Curricular/2024_25/jan/03_01_2024_DISASTER_MANAGEMENT_SEMINAR/${image.src.split('/').pop()}`),
      alt: image.title,
    })),
    date: "03/01/2024",
  },



];

const curricularEventsData_2023_24: Array<CurricularEventObject> = [];

const curricularEventsData_2022_23: Array<CurricularEventObject> = [];

const curricularEventsData_2021_22: Array<CurricularEventObject> = [];

const curricularEventsData_2020_21: Array<CurricularEventObject> = [];

const curricularEventsData_2019_20: Array<CurricularEventObject> = [];

const years: Years = [
  { year: "2026-27", data: curricularEventsData_2026_27 },
  { year: "2025-26", data: curricularEventsData_2025_26 },
  { year: "2024-25", data: curricularEventsData_2024_25 },
  { year: "2023-24", data: curricularEventsData_2023_24 },
];

const formatDate = (dateString: string) => {
  const [day, month, year] = dateString.split("/");
  return new Date(`${year}-${month}-${day}`);
};

const RenderEvent = ({ data }: EventsProps) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

  return (
    <>
      {data?.map((item, index) => {
        const isMultiImages = Array.isArray(item?.img) && item?.img?.length > 1;
        const imageToShow = (item?.img ? item?.img[0]?.src : "") as string;
        return (
          <Grid
            key={index}
            item
            p={2}
            margin={"auto"}
            flexWrap={"wrap"}
            sx={{
              minWidth: {
                xs: "100%",
                md: 400,
              },
              maxWidth: {
                xs: "100%",
                md: 400,
              },
            }}
          >
            <Card
              sx={{
                alignContent: "space-between",
                minWidth: {
                  xs: "100%",
                },
                maxWidth: {
                  xs: "100%",
                },
                minHeight: "400px",
                maxHeight: "400px",
                position: "relative",
              }}
            >
              {
                <>
                  {isMultiImages ? (
                    <Box sx={{ position: "relative" }}>
                      <ImageSlideshow
                        sx={{}}
                        images={item?.img as Array<ImageType>}
                        showCaption={false}
                      />
                      <Box
                        sx={{
                          position: "absolute" as "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                        onClick={() => {
                          setTitle(item?.title);
                          setSliderImages(item?.img);
                          setOpen(true);
                        }}
                      >
                        <ZoomInRounded
                          sx={{
                            color: "#fdd025",
                            zIndex: 99,
                            fontSize: "4rem",
                            "&:hover": {
                              fontSize: "6rem",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box sx={{ position: "relative" }}>
                      <CardMedia
                        component="img"
                        height="240px"
                        sx={{
                          pt: 1,
                          margin: "auto",
                          objectFit: "cover",
                        }}
                        image={imageToShow}
                        alt={item?.title as string}
                      />
                      <Box
                        sx={{
                          position: "absolute" as "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                        onClick={() => {
                          setTitle(item?.title);
                          setSliderImages(item?.img);
                          setOpen(true);
                        }}
                      >
                        <ZoomInRounded
                          sx={{
                            color: "#fdd025",
                            zIndex: 2,
                            fontSize: "4rem",
                            "&:hover": {
                              fontSize: "6rem",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                  <Divider sx={{ py: 1 }} />
                </>
              }
              <CardContent>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      color: theme.palette.primary.contrastText,
                      padding: "10px", // Added padding
                    }}
                  >
                    {item?.title}
                  </Typography>
                  {item?.description && (
                    <Typography
                      variant="subtitle1"
                      sx={{
                        textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        color: theme.palette.grey[900],
                        p: 2,
                      }}
                    >
                      {item?.description}
                    </Typography>
                  )}
                </Box>
              </CardContent>
              <Typography
                sx={{
                  color: "black",
                  position: "absolute",
                  bottom: 16,
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                {formatDate(item?.date as string).toLocaleDateString("en-GB")}
              </Typography>
            </Card>
          </Grid>
        );
      })}
      {data?.length === 0 && <Box sx={{ p: 4 }}>No Data</Box>}
      {sliderImages && (
        <TransitionsModal
          open={open}
          setOpen={setOpen}
          title={title}
          children={
            <Grid item xs={12} margin={"auto"}>
              <Box sx={{ width: "75%", margin: "auto" }}>
                <ImageSlider images={sliderImages} />
              </Box>
            </Grid>
          }
        />
      )}
    </>
  );
};

const CurricularEvents = () => {
  const [year, setYear] = useState("2026-27");
  const [month, setMonth] = useState<keyof typeof monthColors>("All");

  const months = [
    "All",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthColors = {
    All: "#f0f0f0",
    January: "#ffadad",
    February: "#ffd6a5",
    March: "#fdffb6",
    April: "#caffbf",
    May: "#9bf6ff",
    June: "#a0c4ff",
    July: "#bdb2ff",
    August: "#ffc6ff",
    September: "#fffffc",
    October: "#ffca3a",
    November: "#8ac926",
    December: "#1982c4",
  };

  const YearTabs = () => (
    <Grid container spacing={2} justifyContent="center" sx={{ mb: 2 }}>
      {years?.map((item) => (
        <Grid item key={item?.year} xs="auto">
          <Chip
            label={item?.year}
            variant="filled"
            sx={{
              color: item?.year === year ? "secondary.main" : "white",
              backgroundColor:
                item?.year === year ? "transparent" : "secondary.main",
              cursor: "pointer",
              border: "2px solid",
              padding: "8px 16px",
              borderRadius: "16px",
              textTransform: "uppercase",
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                color: "black",
                backgroundColor: "transparent",
                border: "2px solid",
                borderColor: "secondary.main",
                "& .MuiChip-label": {
                  textDecoration: "underline",
                },
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
            onClick={() => setYear(item?.year)}
          />
        </Grid>
      ))}
    </Grid>
  );

  const filteredEvents = years
    .find((item) => item.year === year)
    ?.data.filter((event) => {
      if (month === "All") return true;
      const eventMonth = new Date(formatDate(event.date as string)).toLocaleString("default", { month: "long" });
      return eventMonth === month;
    }) as Array<CurricularEventObject>;

  const getEventCountByMonth = (month: string) => {
    if (month === "All") return years.find((item) => item.year === year)?.data.length || 0;
    return years
      .find((item) => item.year === year)
      ?.data.filter((event) => {
        const eventMonth = new Date(formatDate(event.date as string)).toLocaleString("default", { month: "long" });
        return eventMonth === month;
      }).length || 0;
  };

  return (
    <ContentLayout>
      <React.Fragment>

        <YearTabs />
        <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
          <Select
            value={month}
            onChange={(e) => setMonth(e.target.value as keyof typeof monthColors)}
            displayEmpty
            sx={{
              minWidth: 200,
              borderRadius: '4px',
              '& .MuiSelect-select': {
                padding: '10px',
                color: 'black',
              },
              '& .MuiMenuItem-root': {
                color: 'black',
              },
              '& .Mui-selected': {
                color: 'black',
              },
            }}
          >
            {months.map((month, index) => (
              <MenuItem key={index} value={month} sx={{ color: "black" }}>
                {month} ({getEventCountByMonth(month)})
              </MenuItem>
            ))}
          </Select>
        </Box>
        <Grid container spacing={2} justifyContent="center">
          <RenderEvent data={filteredEvents} />
        </Grid>
      </React.Fragment>
    </ContentLayout>
  );
};

export default CurricularEvents;
